import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import WeekSelect from '@supervisor/punch/WeekSelect';
import WeekCalendarEmployee from '@supervisor/punch/WeekCalendarEmployee';
import PunchForm from '@supervisor/punch/PunchForm';
import i18next from 'i18next';
import * as StatusEntries from '@scripts/StatusEntries';
import * as ApprobationStructure from '@scripts/ApprobationStructure';
import LegendTypeDay from '@supervisor/punch/LegendTypeDay';
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { gearIcon, plusIcon, checkIcon } from "@progress/kendo-svg-icons";
import { withNamespaces } from 'react-i18next';
import Button from 'react-bootstrap-button-loader';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import PunchDaysDetail from '@supervisor/punch/PunchDaysDetail';
import styles from '@styles/punchApproval.module.css';
import Popup from '@controls/Popup';
import { mode } from '@scripts/Mode';
import { getPunchApprovalList } from '@actionsSup/punchApproval';
import * as StatusCode from '@scripts/StatusCode';
import * as StatusApprove from "@scripts/PunchApproveStatus";
import { punchApprove } from "@actionsSup/punchApproval";
import * as storage from '@storage'
import thumbsDown from "@images/thumbsDown2.png";
import thumbsUp from "@images/thumbsUp2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle1, faCircle2, faCircleXmark, faCircleCheck } from "@fortawesome/pro-duotone-svg-icons";
import AlertAlgo from '@controls/AlertSnack';
import LoadingLayer from '@controls/LoadingLayer';
import { sleep, isIOS } from '@utils/index';
import { format } from '@utils';
import * as PageSourceCode from '@scripts/PageSourceCode';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    divRoot: {
        maxWidth: '800px',
        justifySelf: 'center',
        width: '100%'
    },
    divScroll: {
        overflow: 'auto'
    },
    divApproved: {
        marginTop: '15px'
    },
    divLegend: {
        bottom: '79px',
        position: 'fixed',
        justifySelf: 'center'
    },
    approveAllButton: {
        '& > span.k-icon': {
            backgroundColor: '#68d179',
            color: '#ffffff'
        }
    },
    appBarForm: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
    },
    divTitleNotApproved: {
        backgroundColor: '#fd6161',
        margin: '10px 6px',
        borderRadius: '10px',
        marginBottom: '10px',
        boxShadow: '1px 1px 4px 1px #b7b6b6',
        height: '46px'
    },
    divTitleApproved: {
        backgroundColor: '#5ab988',
        margin: '10px 6px',
        borderRadius: '10px',
        marginBottom: '10px',
        boxShadow: '1px 1px 4px 1px #b7b6b6',
        height: '46px'
    },
    title: {
        display: 'table',
        textAlign: 'left',
        padding: '10px',
        color: '#ffffff',
        float: 'left'
    },
    titleLvl: {
        float: 'right',
        fontSize: '24px',
        padding: '4px',
        marginRight: '4px',
        color: '#ffffff'
    },
    approved: {
        float: 'left',
        height: '30px',
        marginTop: '8px',
        marginLeft: '8px',
        color: '#ffffff'
    },
    notApproved: {
        float: 'left',
        height: '30px',
        marginTop: '8px',
        marginLeft: '8px',
        color: '#ffffff'
    }
}));

function PunchApproval(props) {
    const classes = useStyles();

    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [data, setData] = React.useState([]);
    const [epct, setEpct] = React.useState(null);
    const [employeeCode, setEmployeeCode] = React.useState(null);
    const [dataNotApproved, setDataNotApproved] = React.useState([]);
    const [dataApproved, setDataApproved] = React.useState([]);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [dataDaysDetail, setDataDaysDetail] = React.useState(null);
    const [levelSelection, setLevelSelection] = React.useState(null);
    const [titleUser, setTitleUser] = React.useState(null);
    const [dataDayDetail, setDataDayDetail] = React.useState(null);
    const [punchMode, setPunchMode] = React.useState(mode.ADD);
    const [punchId, setPunchId] = React.useState(null);
    const [isReload, setIsReload] = React.useState(false);
    const [isRefreshPunchDaysDetail, setIsRefreshPunchDaysDetail] = React.useState(false);
    const [isPunchFormError, setIsPunchFormError] = React.useState(false);
    const [openPunchForm, setOpenPunchForm] = React.useState(false);
    const [titlePunchForm, setTitlePunchForm] = React.useState('');
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [isProcessing, setIsProcessing] = React.useState(true);
    const [openConfirmApprove, setOpenConfirmApprove] = React.useState(false);

    const useDoubleApprobation = storage.getUseDoubleApprobation();
    const approbationStructure = storage.getApprobationStructure();
    const isLevel2Approbator = storage.getIsLevel2Approbator();
    const alertRef = useRef(null);
    const isiOS = isIOS();

    const handleTitle = () => {
        if (props.onLoadTitle != null) {
            props.onLoadTitle(i18next.t('menu:punchApproval'));
        }
    }

    useEffect(() => {
        handleTitle();
        resizeForm();
    }, []);

    useEffect(() => {
        // This is to set the status that will be used to display the punchs that are approved
        // The approved green icon will be shown
        if (dataNotApproved?.length > 0) {
            dataNotApproved.forEach(item => {
                let listPunch = item.lst2;;

                if (listPunch.length > 0) {
                    listPunch.forEach(subItem => {
                        // We need to check if subItem.status == null, because if the status is already setted outside we do not change the status
                        if (subItem.status == null) {
                            if (subItem.isAp == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        }
                    })
                }
            });
        }
    }, [dataNotApproved]);

    useEffect(() => {
        if (startDate != null && endDate != null) {
            loadList();
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (!openPunchForm
            && isReload) {
            setIsRefreshPunchDaysDetail(true);
            setIsReload(false);
        }
    }, [openPunchForm]);

    const loadList = async () => {
        setIsProcessing(true);
        await sleep(500);

        var response = await getPunchApprovalList(startDate, endDate);
        
        if (response != null && response.status == StatusCode.STATUS_OK) {
            if (response.result.length > 0) {
                if (!useDoubleApprobation) {
                    const dataNotApproved = response.result.filter(x => x.lst2.length > 0);;
                    const dataApproved = response.result.filter(x => x.lstAp.length > 0 &&
                        x.lst2.length == 0);

                    setDataNotApproved(dataNotApproved);
                    setDataApproved(dataApproved);
                } else {
                    if (approbationStructure == ApprobationStructure.DEPARTMENT) {
                        const dataNotApproved = response.result.filter(x => x.lst1.length > 0 || x.lst2.length > 0);

                        const dataApproved = response.result.filter(x => x.lstAp.length > 0 &&
                            x.lst1.length == 0 &&
                            x.lst2.length == 0);

                        setData(response.result);
                        setDataNotApproved(dataNotApproved);
                        setDataApproved(dataApproved);
                    } else {
                        const dataNotApproved = response.result.filter(x => x.lst1.length > 0 || x.lst2.length > 0);

                        const dataApproved = response.result.filter(x => x.lstAp.length > 0 &&
                            x.lst1.length == 0 &&
                            x.lst2.length == 0);

                        setDataNotApproved(dataNotApproved);
                        setDataApproved(dataApproved);
                    }
                }
            } else {
                setDataNotApproved(null);
                setDataApproved(null);
            }
            setIsProcessing(false);
        }
    }

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const weekSelect = document.querySelector('#divWeekSelect').clientHeight;
            const legend = document.querySelector('#divLegend').clientHeight;
            const noData = document.querySelector('#divNoData').clientHeight;
            const offSet = 40;

            const customHeight = height - titleBar - menu - weekSelect - legend - noData - offSet;

            const element = document.querySelector('#divScroll');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 350);
    }

    const onChangeDate = (startDate, endDate) => {
        setStartDate(new Date(startDate + ' 00:00'));
        setEndDate(new Date(endDate + ' 00:00'));
    }

    const handleClick = (eventType) => {
        switch (eventType.itemIndex) {
            case undefined:
            case 0:
                // Approve all
                handleOpenConfirmApprove();
                break;
            case 1:
                // Add punch
                dialogDetail.handleNewPunch();
                break;
            default:
                break;
        }
    }

    const items = [
        {
            svgIcon: checkIcon,
            text: i18next.t('punchApproval:button.approveAll'),
            className: classes.approveAllButton,
            disabled: !(dataNotApproved && dataNotApproved.length > 0)

        },
        {
            svgIcon: plusIcon,
            text: i18next.t('punchApproval:button.add'),
            disabled: false
        }
    ];

    const handleApproveAll = () => {
        // Get all punchIds
        const isApprove = true;

        dataNotApproved.forEach(async (item) => {
            const employeeCode = item.ec;
            const punchIds = item.lst.filter(x => (x.myL == 1 && x.canAp1 == true) || (x.myL == 2 && x.canAp2 == true) || (x.myL == 0 && x.canAp == true && x.isAp == false))
                .map(x => ({ punchId: x.pchId, level: x.myL }));

            if (punchIds.length <= 0) {
                return;
            }

            const response = await punchApprove(punchIds, isApprove);

            const result = handleResponsePunch(response);

            //const isApproveStatus = result == StatusApprove.STATUS_APPROVED;
            const isApproveStatus = result == StatusApprove.STATUS_APPROVED || StatusApprove.STATUS_PARTIAL_APPROVED;

            setDataNotApproved(prevData => {
                const parsedResponse = response.map(x => JSON.parse(x));

                const targetData = prevData.find(x => x.ec === employeeCode);
                if (!targetData || !Array.isArray(targetData.lst)) {
                    return prevData;
                }

                let isAp;

                const updatedLst = targetData.lst.map(item => {
                    const objWarning = parsedResponse.find(x => x.obj.punchCrypt === item.pchId && x.warning === true);
                    const objError = parsedResponse.find(x => x.obj.punchCrypt === item.pchId && x.error === true && x.warning === false);

                    const messageWarning = objWarning ? objWarning.message : '';
                    const messageError = objError ? objError.message : '';

                    let messageFinal = '';
                    let status = StatusApprove.STATUS_APPROVED;

                    isAp = isApprove;

                    if (objWarning) {
                        messageFinal = messageWarning;
                        status = StatusApprove.STATUS_WARNING;
                    } else if (objError) {
                        messageFinal = messageError;
                        status = StatusApprove.STATUS_ERROR;
                        isAp = !isApprove;
                    }

                    item.message = messageFinal;
                    item.status = status;

                    if (parsedResponse.find(x => x.obj.punchCrypt === item.pchId)) {
                        if (useDoubleApprobation && item.myL == 1) {
                            item.isAp1 = isAp;
                        } else {
                            item.isAp = isAp;
                        }
                    }

                    return {
                        ...item,
                        //messageFinal,
                        //status,
                        //isAp
                    };
                });

                return prevData.map(item => {
                    if (item.ec === employeeCode) {
                        item.canAp1 = !isAp;
                        item.canAp = !isAp;

                        if (!useDoubleApprobation) {
                            // Copy isAp, status and message from lst to lst2 (matching by punchId)
                            const apMap = new Map(
                                item.lst.map(subitem => [
                                    subitem.pchId,
                                    { isAp: subitem.isAp, status: subitem.status, message: subitem.message }
                                ])
                            );
                            item.lst2 = item.lst2.map(subitem => ({
                                ...subitem,
                                isAp: apMap.get(subitem.pchId)?.isAp ?? subitem.isAp,  // preserve old if not found
                                status: apMap.get(subitem.pchId)?.status ?? subitem.status,  // preserve old if not found
                                message: apMap.get(subitem.pchId)?.message ?? subitem.message,  // preserve old if not found
                            }));
                        }

                        return {
                            ...item,
                            lst: updatedLst,
                            isAp: isApproveStatus
                        };
                    }

                    return item;
                });
            });

            alertRef.current.showMessageSuccess(i18next.t('punchApproval:message.approveAll'));

            handleCloseConfirmApprove();
        })
    }

    const handleResponsePunch = (response) => {
        let status = StatusApprove.STATUS_APPROVED;

        let qtySuccess = 0;
        let qtyFailed = 0;

        response.forEach(item => {
            const obj = JSON.parse(item);

            if (obj.error == true) {
                qtyFailed++;
            } else if (obj.success) {
                qtySuccess++;
            }
        });

        if (qtyFailed > 0 && qtySuccess > 0) {
            status = StatusApprove.STATUS_PARTIAL_APPROVED;
        } else if (qtyFailed > 0) {
            status = StatusApprove.STATUS_NOT_APPROVED;
        }

        return status;
    }

    const handleStatusPunchList = (list, level) => {
        let punchList;

        if (list != null && list.length > 0) {
            list.forEach(item => {
                if (useDoubleApprobation) {
                    if (level == 1) {
                        punchList = item.lst1
                    } else {
                        punchList = item.lst2;
                    }
                } else {
                    punchList = item.lst;
                }

                if (punchList.length > 0) {
                    punchList.forEach(subItem => {
                        if (subItem.status == null) {
                            if (approbationStructure == ApprobationStructure.DEPARTMENT && !isLevel2Approbator) {
                                // Level 1
                                if (subItem.isAp1 == true) {
                                    subItem.status = StatusApprove.STATUS_APPROVED;
                                } else {
                                    subItem.status = StatusApprove.STATUS_NONE;
                                }
                            } else if (approbationStructure == ApprobationStructure.DEPARTMENT && isLevel2Approbator) {
                                // Level 2
                                if (subItem.isAp == true) {
                                    subItem.status = StatusApprove.STATUS_APPROVED;
                                } else {
                                    subItem.status = StatusApprove.STATUS_NONE;
                                }
                            }
                        }
                    })
                }
            });
        } else if (list != null) {
            if (useDoubleApprobation) {
                if (level == 1) {
                    punchList = list.lst1
                } else if (level == 2) {
                    punchList = list.lst2;
                } else {
                    punchList = list.lst;
                }
            } else {
                punchList = list.lst;
            }

            if (punchList.length > 0) {
                punchList.forEach(subItem => {
                    if (subItem.status == null) {
                        if (approbationStructure == ApprobationStructure.DEPARTMENT && !isLevel2Approbator) {
                            // Level 1
                            if (subItem.isAp1 == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        } else if (approbationStructure == ApprobationStructure.DEPARTMENT && isLevel2Approbator) {
                            // Level 2
                            if (subItem.isAp == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        } else if (approbationStructure == ApprobationStructure.PROJECT && subItem.myL == 1) {
                            // Level 1
                            if (subItem.isAp1 == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        } else if (approbationStructure == ApprobationStructure.PROJECT && subItem.myL == 2) {
                            // Level 2
                            if (subItem.isAp == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        } else {
                            if (subItem.isAp == true) {
                                subItem.status = StatusApprove.STATUS_APPROVED;
                            } else {
                                subItem.status = StatusApprove.STATUS_NONE;
                            }
                        }
                    }
                })
            }
        }
    }

    const dialogDetail = {
        handleOpenDetail: (epct, employeeCode, category, level) => {
            setEpct(epct);
            setEmployeeCode(employeeCode);
            let dataDetails;
            if (category == StatusEntries.Unapproved) {
                const punchNotApproved = dataNotApproved;
                dataDetails = punchNotApproved.filter(x => x.ec == employeeCode)[0];
            } else {
                dataDetails = dataApproved.filter(x => x.ec == employeeCode)[0];
            }
            handleStatusPunchList(dataDetails, level);
            setDataDayDetail(dataDetails);
            setLevelSelection(level);
            setTitleUser(`${employeeCode} - ${dataDetails.n}`);
            setOpenDetail(true);
        },
        handleCloseDetailClick: () => {
            setLevelSelection(null);
            setEpct(null);
            setEmployeeCode(null);
            loadList();
            setOpenDetail(false);
        },
        handleNewPunch: () => {
            // Open punch form
            dialogPunch.handleOpenPunchForm();
        },
        handleEditPunch: (id, idCrypt) => {
            // Open punch form            
            dialogPunch.handleOpenPunchForm(id, idCrypt, mode.EDIT);
        },
        onLoadComplete: () => {

        }
    }

    const dialogPunch = {
        handleOpenPunchForm: (id = 0, idCrypt = null, md = mode.ADD) => {
            let title = i18next.t('punchApproval:title.add_punch');

            if (md === mode.COPY) {
                title = format(i18next.t('punchApproval:title.copy_punch'), id);
            } else if (md === mode.EDIT) {
                title = format(i18next.t('punchApproval:title.edit_punch'), id);
            }

            setPunchId(idCrypt);
            setPunchMode(md);
            setTitlePunchForm(title);
            setOpenPunchForm(true);
        },
        handleClosePunchForm: (reload, isError) => {
            if (reload || isReload) {
                if (openDetail === false) {
                    if (!isError) {
                        alertRef.current.showMessageSuccess(i18next.t('punchApproval:message.update-success'));
                    } else {
                        alertRef.current.showMessageError(i18next.t('error:generic-error'));
                    }

                    if (startDate != null && endDate != null) {
                        loadList();
                    }
                    setIsReload(false);
                } else if (isError) {
                    setIsPunchFormError(true);
                    alertRef.current.showMessageError(i18next.t('error:generic-error'));
                }
            }            
            
            setOpenPunchForm(false);
        }
    }

    const handleOpenConfirmApprove = () => {
        setOpenConfirmApprove(true);
    }

    const handleCloseConfirmApprove = () => {
        setOpenConfirmApprove(false);
    }

    return (
        <LoadingLayer isActive={isProcessing}>
            <div id="divPunchApproval" className={classes.divRoot}>
                <WeekSelect onChangeDate={onChangeDate} selectedDate={selectedDate} refresh={loadList} />
                <div id="divScroll" className={classes.divScroll}>
                    <div id="divNoData">
                        {(dataNotApproved == null && dataApproved == null) &&
                            i18next.t('common:no-data')
                        }
                    </div>
                    {dataNotApproved && dataNotApproved.length > 0 &&
                        <>
                            <div>
                                <div className={classes.divTitleNotApproved}>
                                    {/*<img className={classes.thumbsDown} src={thumbsDown} />*/}
                                    <FontAwesomeIcon icon={faCircleXmark} className={classes.notApproved} />
                                    <span className={classes.title}>{i18next.t('punchApproval:title.unapproved_entries')}</span>
                                </div>
                                <WeekCalendarEmployee
                                    data={dataNotApproved}
                                    intervalDate={{ startDate: startDate, endDate: endDate }}
                                    category={StatusEntries.Unapproved}
                                    detailDialogEvent={{
                                        open: dialogDetail.handleOpenDetail,
                                        close: dialogDetail.handleCloseDetailClick
                                    }}
                                />
                            </div>
                        </>
                    }
                    <div className={classes.divApproved}>
                        {dataApproved && dataApproved.length > 0 &&
                            <>
                                <div className={classes.divTitleApproved}>
                                    {/*<img className={classes.thumbsUp} src={thumbsUp} />*/}
                                    <FontAwesomeIcon icon={faCircleCheck} className={classes.approved} />
                                    <span className={classes.title}>{i18next.t('punchApproval:title.approved_entries')}</span>
                                </div>
                                <WeekCalendarEmployee
                                    data={dataApproved}
                                    intervalDate={{ startDate: startDate, endDate: endDate }}
                                    category={StatusEntries.Approved}
                                    detailDialogEvent={{
                                        open: dialogDetail.handleOpenDetail,
                                        close: dialogDetail.handleCloseDetailClick
                                    }}
                                />
                            </>
                        }
                    </div>
                </div>
                <div id="divLegend" className={classes.divLegend}>
                    <LegendTypeDay />
                </div>

                <FloatingActionButton className={`addButtonFab floatingActionButton`} svgIcon={gearIcon} items={items} onItemClick={handleClick} />

                <Dialog style={{ zIndex: '10000' }} fullScreen open={openDetail} onClose={dialogDetail.handleCloseDetailClick} TransitionComponent={Transition}>
                    <div data-id="headerPunchDetail">
                        <AppBar className={classes.appBarForm}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={dialogDetail.handleCloseDetailClick} aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={classes.titleAppBarForm}>
                                    {titleUser}
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </div>
                    <div data-id="divPunchDetail">
                         <Fab color="primary" aria-label="add" className={styles.addButtonFabDetail} onClick={dialogDetail.handleNewPunch} >
                            <AddIcon />
                        </Fab>
                        <PunchDaysDetail onEditPunch={dialogDetail.handleEditPunch} forceReload={isRefreshPunchDaysDetail} setForceReload={setIsRefreshPunchDaysDetail} data={dataDayDetail} employeeCode={employeeCode} startDate={startDate} endDate={endDate} level={levelSelection} handleStatusPunchList={handleStatusPunchList} onLoadComplete={dialogDetail.onLoadComplete} isPunchFormError={isPunchFormError} setIsPunchFormError={setIsPunchFormError} />
                    </div>
                </Dialog>
                <Popup title={titlePunchForm} openPop={openPunchForm} handleClosePop={dialogPunch.handleClosePunchForm}>
                    <PunchForm id={punchId} openDetail={openDetail} mode={punchMode} load={loadList} setIsReload={setIsReload} epct={epct} handleClose={dialogPunch.handleClosePunchForm} setTitlePunchForm={setTitlePunchForm} />
                </Popup>
                <Dialog
                    open={openConfirmApprove}
                    onClose={handleCloseConfirmApprove}
                    aria-labelledby="draggable-dialog-title"
                    style={{ zIndex: 10001 }}
                >
                    <DialogTitle id="draggable-dialog-title">
                        Confirmation
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {i18next.t('punchApproval:message.confirmation-approveAll')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseConfirmApprove} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('buttons:no')}
                        </Button>
                        <Button autoFocus onClick={() => handleApproveAll()} color="primary" className={styles.buttonYesNo} variant="success">
                            {i18next.t('buttons:yes')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <AlertAlgo ref={alertRef} />
            </div>
        </LoadingLayer>
    )
}

export default withNamespaces(['punchApproval', 'menu', 'common'], { wait: true })(PunchApproval);